App.PromoCardComponent = Em.Component.extend
  classNames: ['promo-card']
  classNameBindings: ['promo.is_working:is-working']

  actions:
    copyReferralLink: ->
      button = $(@element).children('.sm-copy-button')
      textToCopy = button.data('clipboard-text')
      alertText = Em.I18n.t 'promo_card.condition.copied'

      if textToCopy
        if navigator.clipboard?
          navigator.clipboard.writeText(textToCopy)
            .then ->
              alert alertText
            .catch (err) ->
              console.error 'Error in copying text: ', err
        else
          $input_field = $('<textarea>')
          $input_field.val(textToCopy)
          $('body').append($input_field)
          $input_field.select()

          try
            successful = document.execCommand('copy')
            if successful
              alert alertText
          catch err

          $input_field.remove()